$(document).ready(function() {
	var viewHeight = $(window).height();
	var bodyHeight = $("body").height();
	if (bodyHeight < viewHeight) {
			$("html").css("height", "100%");
			$("body").css("height", "100%");
			}
});



// WEBPACK FOOTER //
// app/frontend/javascripts/footer_bottom.js